<template>
  <div class="image-text">
    <slot name="image"></slot>
    <slot name="text"></slot>
  </div>
</template>

<script>
export default {
  name: "ImageTextRightBottom",
};
</script>

<style lang="scss" scoped>
.image-text {
  align-items: flex-end;

  @include mobile {
    flex-direction: column;
  }

  p {
    flex: 1;
  }

  img {
    flex: 3;
  }
}
</style>
